var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuperbetStorePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 54,
    viewBox: "0 0 44 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3009_355)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9683 7.40846C32.8863 3.19851 27.5699 0.878906 22.0001 0.878906C16.4251 0.878906 11.1087 3.19851 7.02407 7.41113C2.8781 11.6877 0.601158 17.4334 0.779794 23.1765C1.28371 39.451 20.4537 52.1235 21.2723 52.6541L21.9895 53.1207L22.7147 52.6621C23.5305 52.1449 42.714 39.779 43.2205 23.1738C43.3965 17.4334 41.1169 11.6851 36.9683 7.40846Z",
    fill: "#E80104"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7507 38.46C18.2524 38.46 14.7545 37.5703 11.6345 35.7905L10.3161 35.0386C10.0157 34.8674 9.91106 34.4851 10.0823 34.1847L11.5858 31.5484C11.757 31.248 12.1393 31.1433 12.4397 31.3146L13.4478 31.8895C18.5935 34.8245 24.9065 34.8245 30.0522 31.8895L31.0604 31.3146C31.3607 31.1433 31.743 31.248 31.9142 31.5484L33.4177 34.1847C33.5889 34.4851 33.4843 34.8674 33.1839 35.0386L31.8655 35.7906C28.7455 37.5703 25.2476 38.46 21.7498 38.46H21.7507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7456 16.9026C24.4009 15.3991 23.5868 14.4281 21.5191 14.4281C19.4514 14.4281 18.7312 15.2113 18.7312 16.245C18.7312 17.4355 19.577 17.8736 21.6443 18.187L24.2757 18.5943C29.4755 19.4088 31.3237 21.3196 31.3237 24.9533C31.3237 29.0256 28.1911 32.1891 21.8325 32.1891C15.4739 32.1891 11.8714 29.6207 12.2161 24.4204H18.3244C18.1679 26.049 18.982 27.3022 21.9581 27.3022C24.2449 27.3022 25.2159 26.5815 25.2159 25.3601C25.2159 24.2952 24.5583 23.7628 22.7727 23.4807L20.2043 23.0734C15.0045 22.2589 12.6238 20.2229 12.6239 16.4327C12.6239 12.6425 15.3166 9.5412 21.613 9.5412C27.5647 9.5412 30.6969 12.2039 30.7912 16.8713L24.7456 16.9026Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3009_355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperbetStorePin);
export default __webpack_public_path__ + "static/media/SuperbetStorePin.108d17500a85964c9f07a7abf8a8aa00.svg";
export { ForwardRef as ReactComponent };